import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {bindActionCreators} from 'redux';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {connect} from 'store';
import {toggleShare, share} from 'store/ui/actions';
import {toggleShareTime, toggleShareSearch} from 'store/config/actions';
import Dialog from 'components/layout/dialog';
import {Section, Field, Toggle} from 'components/forms';

export class Share extends Component {
    static propTypes = {
        opened: PropTypes.bool.isRequired,
        config: ImmutablePropTypes.map.isRequired,
        share: PropTypes.func.isRequired,
        toggleShare: PropTypes.func.isRequired,
        toggleShareTime: PropTypes.func.isRequired,
        toggleShareSearch: PropTypes.func.isRequired,
    };

    state = {
        copied: false,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.opened !== this.props.opened
            || nextProps.config !== this.props.config
            || nextProps.share !== this.props.share
            || nextProps.toggleShare !== this.props.toggleShare
            || nextProps.toggleShareTime !== this.props.toggleShareTime
            || nextProps.toggleShareSearch !== this.props.toggleShareSearch;
    }

    @autobind
    setUrlRef(ref) {
        this.url = ref;
    }

    @autobind
    resetCopied() {
        this.setState({copied: false});
    }

    @autobind
    copyToClipboard() {
        this.setState({copied: true});
        clearTimeout(this.resetCopiedTimeout);
        this.resetCopiedTimeout = setTimeout(this.resetCopied, 5000);

        this.url.select();
        document.execCommand('copy');
        this.url.focus();
        this.url.blur();
    }

    @autobind
    handleServiceClick(service) {
        return () => this.props.share(service);
    }

    render() {
        const {opened, config} = this.props;
        const {copied} = this.state;

        return (
            <div className='cielo24-vwrap-share'>
                <button
                    type='button'
                    className={classNames('cielo24-vwrap-toggle', {'cielo24-vwrap-opened': opened})}
                    title={i18next.t('Share')}
                    aria-label={i18next.t('Share')}
                    onClick={this.props.toggleShare}
                >
                    <i aria-hidden={true} className='cielo24-vwrap-icon cielo24-vwrap-icon-share' />
                </button>
                <Dialog title={i18next.t('Share')} opened={opened} onClose={this.props.toggleShare}>
                    <Section>
                        <Field label={i18next.t('Share Search')}>
                            <Toggle
                                value={config.get('shareSearch')}
                                onChange={this.props.toggleShareSearch}
                            />
                        </Field>
                    </Section>
                    <Section>
                        <Field label={i18next.t('Share Time')}>
                            <Toggle
                                value={config.get('shareTime')}
                                onChange={this.props.toggleShareTime}
                            />
                        </Field>
                    </Section>
                    <Section>
                        <div className='cielo24-vwrap-url'>
                            <input type='text' ref={this.setUrlRef} value={config.get('shareUrl')} readOnly={true} />
                            <button type='button' className='cielo24-vwrap-copy' onClick={this.copyToClipboard}>
                                {copied ? 'Copied!' : 'Copy'}
                            </button>
                        </div>
                    </Section>
                    <Section>
                        <div className='cielo24-vwrap-services'>
                            <button
                                type='button'
                                className='cielo24-vwrap-service'
                                title='Facebook'
                                aria-label='Facebook'
                                onClick={this.handleServiceClick('facebook')}
                            >
                                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-facebook' aria-hidden={true} />
                            </button>
                            <button
                                type='button'
                                className='cielo24-vwrap-service'
                                title='Twitter'
                                aria-label='Twitter'
                                onClick={this.handleServiceClick('twitter')}
                            >
                                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-twitter' aria-hidden={true} />
                            </button>
                            <button
                                type='button'
                                className='cielo24-vwrap-service'
                                title='Google'
                                aria-label='Google'
                                onClick={this.handleServiceClick('google')}
                            >
                                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-google-plus' aria-hidden={true} />
                            </button>
                            <button
                                type='button'
                                className='cielo24-vwrap-service'
                                title='Linkedin'
                                aria-label='Linkedin'
                                onClick={this.handleServiceClick('linkedin')}
                            >
                                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-linkedin' aria-hidden={true} />
                            </button>
                            <button
                                type='button'
                                className='cielo24-vwrap-service'
                                title='Email'
                                aria-label='Email'
                                onClick={this.handleServiceClick('email')}
                            >
                                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-email' aria-hidden={true} />
                            </button>
                        </div>
                    </Section>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    opened: state.ui.get('shareOpened'),
    config: state.config,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {toggleShareTime, toggleShareSearch, toggleShare, share},
    dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Share);



// WEBPACK FOOTER //
// ./scripts/components/footer/share.js